module.exports = __webpack_public_path__ + "img/kkb_hdmi_adapter.2a82d7c1.jpg";